import { BeckyThemeProvider } from '@coolblue-development/themes';
import { useCallback, useEffect, useState } from 'react';
import CassieInjector from './components/CassieContainer/CassieInjector';
import { CassieWebsocketContextProvider } from './components/CassieContainer/websocket/CassieWebsocketContext';
import CatoContainer from './components/CatoContainer/CatoContainer';
import { CssBaseline } from '@mui/material';
import ErrorBoundary from './ErrorBoundary';
import ToolkitPanel from './components/ToolkitPanel/ToolkitPanel';
import { initializeDatadogRum } from './utils/initializeDatadogRum';
import { initializeDatadog } from './utils/initializeDatadog';
import { appTheme } from './theme';
import { CloseContext } from './components/CassieContainer/websocket/types';
import { getUsageMode } from './utils/usageMode';

interface CatoConfProps {
  ccpInstanceURL: string;
  cppSamURL: string;
  title?: string;
  region: string;
}

function App({ ccpInstanceURL, cppSamURL, title, region }: CatoConfProps): JSX.Element {
  const [contactId, setContactId] = useState<string | undefined>(undefined);
  const [closeContext, setCloseContext] = useState<CloseContext | undefined>(undefined);

  useEffect(() => {
    if (title) document.title = title;
  }, [title]);

  useEffect(() => {
    initializeDatadog();
    initializeDatadogRum();
  }, []);

  const handleViewContact = useCallback((newContactId: string | undefined, newCloseContext?: CloseContext) => {
    setCloseContext(newCloseContext);
    if (!newContactId) {
      setContactId(undefined);
      return;
    }
    setContactId(newContactId);
  }, []);

  return (
    <>
      <BeckyThemeProvider theme={appTheme}>
        <ErrorBoundary>
          {/* Solvie's shell owns the page's global styles; don't reset them from inside a pane. */}
          {getUsageMode() !== 'solvie' && <CssBaseline />}
          <CassieWebsocketContextProvider>
            <CatoContainer
              region={region}
              instanceURL={ccpInstanceURL}
              samURL={cppSamURL}
              onViewContact={handleViewContact}
            />
            <CassieInjector contactId={contactId} closeContext={closeContext} />
          </CassieWebsocketContextProvider>
          <ToolkitPanel />
        </ErrorBoundary>
      </BeckyThemeProvider>
    </>
  );
}

export default App;
